module.exports = __webpack_public_path__ + "static/media/photo197.94d6782f.jpg";